"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function forDocumentLoad() {
    return new Promise(function (resolve) {
        document.addEventListener('DOMContentLoaded', function () {
            resolve();
        });
    });
}
exports.forDocumentLoad = forDocumentLoad;
